const Base = 'DashboardTodoList' as const;

/**
 * Имена продуктовых событий виджета чек-листа на дашборде (дерево → строки вида DashboardTodoList.*).
 * Значение и additional передаются в logEventString отдельно.
 * @see https://events.chv.yandex-team.ru/projects/yastore-b2b
 */
export const dashboardTodoListLoggingEvents = {
    Show: `${Base}.Show`,
    ItemToggleComplete: `${Base}.ItemToggleComplete`,
    StepMoveForward: `${Base}.StepMoveForward`,
    StepMoveBackward: `${Base}.StepMoveBackward`,
    MarkdownLinkClick: `${Base}.MarkdownLinkClick`,
} as const;
